<style src='@/resources/styles/payment_overlay.css' scoped></style>

<template>
        <div class="overlay">
            <div class="contents">
                <!-- Hiding gif for now - @JR plz put a gif or something here that works -->
                <div class='spirit-guide'></div>
                <h1>{{text}}</h1>
                <h3 v-if="loadingStatus !== ''">{{loadingStatus}}</h3>
            </div>
        </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'PaymentOverlay',
      props: {
          text: String,
      },
      computed: {
          ...mapGetters(['state', "loadingStatus", "loadingProgress", "filters"]),
      }
  }
</script>